import React from "react";
import { DialogProps } from '@material-ui/core';

export interface IAlertDialog extends IProps, IHandlers {}

/**
 * Properties passed in from angular instantiation.
 * This can include functions/handlers that simply call back to the Angular parent component
 * and do not need to modify app state (via a service).
 */
export interface IContainerProps {

  /** Header text of the dialog */
  dialogHeaderText?: string;

  /** True, when alert dialog is displayed */
  showAlertDialog: boolean;

  /** Content to be rendered inside the dialog */
  children: React.ReactNode;

  /** Text to be displayed for the button. By default, it's value is "OK". */
  closeButtonText?: string;

  /** Method to be called, when alert dialog is closed */
  onAlertDialogClose: () => void;

  /**
   * Customise the width of the dialog by passing values such as 'xs', 'sm', 'md', 'lg', 'xl' and false.
   * By default, it's value is 'sm'.
  */
  dialogWidth?: DialogProps['maxWidth'];

  /** True, when close button must be displayed at the dialog header */
  shouldShowCloseButton?: boolean;

  /** True, when action buttons must be displayed at the dialog footer */
  shouldShowActionButtons?: boolean;
}

/**
 * Properties passed directly into the react component. If the container is responsible for fetching async data, via a
 * service, these may differ from IContainerProps.
 */
export interface IProps extends IContainerProps {}

/**
 * Handlers used to modify app state (via a service) from within the module's container.
 * Similar to redux mapDispatchToProps.
 */
 export interface IHandlers {
  onAlertDialogClose: () => void;
}

export const classPrefix = 'AlertDialog';
